import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

// Utils

// UI
import { Container, DateLayer, closeLayerFn, openLayerFn } from "../../Layout";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { SUBS, SubMenu } from "../Pmr";

// Provider
import styled from "styled-components";
import {
  AppContext,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
  SocketCommand,
  checkMobile,
  socketManager,
} from "../../../components/AppProvider";
import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { PostApi1702, PostApi1703 } from "../../../modules/network/padoPost";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { IC } from "../../../resources/Assets";
import NothingImg from "../../../resources/images/icon/icon_medicine_list.png";
import OtherInspactionComponent from "./OtherInspactionComponent";

import { requestGetNewPoint } from "../../../modules/utils/getNewPoint";
import { checkMsgCount } from "../PmrLayout";
import SkeletonPmr from "../../common/Skeleton/SkeletonPmr";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  useTitle("개인진료기록_기타자료");
  const { auth, userinfo, cfg, phonecfg, dispatch, pageState, itemState } =
    useContext(AppContext);
  // msgCount
  const [msgCount, setMsgCount] = useState("");

  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[1];

  const [periodIndex, setPeriodIndex] = useState(2);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [pdhType, setPdhType] = useState(4);
  const [hpCode, setHpCode] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [modalityName, setModalityName] = useState("");
  const [trsmId, setTrsmId] = useState();

  const [list, setList] = useState(null);
  const [hospitalList, setHospitalList] = useState("");
  const [modalityList, setModalityList] = useState("");
  const [trgtHsptList, setTrgtHsptList] = useState([]);

  const [dataList, setDataList] = useState(null);
  const [deleteSeqNo, setDeleteSeqNo] = useState();
  const [loading, setLoading] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [checkedSeqNo, setCheckedSeqNo] = useState([]);

  // 공유버튼 활성화 상태
  const [shareMode, setShareMode] = useState(0);

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  const handleAlert = () => {
    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const openConfirmLayer = trsmId => {
    openLayerFn($(".confirm-layer"));
    // setTrsmId(trsmId);
    // request556(userinfo, cfg, phonecfg, trsmId, setTrsmId);
  };

  const fnConfirmLayer = () => {
    // bizSubType : 0 진료자료, 1 기타자료, 2 교육자료 , 3 제증명
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "delete",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        { masterKey1: deleteSeqNo.toString(), masterKey2: "", masterKey3: "" },
      ],

      bizType: "ED",
      bizName: "기타입력자료",
      bizDtlType: "",
      viewYN: "Y",
      saveExtYN: "N",
      colorType: "PP",
      hsptSharYn: "N",
      bizSubType: "1",
      redirectURL: "cnntHspt/1",
    });
  };

  const fnCancelConfirmLayer = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const etcInputClick = () => {
    socketManager(SocketCommand.ETC_INPUT_DATA, undefined, {
      procType: "I",
      seqNo: 0,
      dataType: "",
      dataDt: "",
      dataTitle: "",
      fileNm: [],
    });
  };

  const request1703 = () => {
    checkMsgCount(
      userinfo,
      cfg,
      phonecfg,
      "9",
      "00000000",
      "99999999",
      setMsgCount
    );

    PostApi1703(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultCode === "E000") {
          setDataList(res.result);
        }
        setLoading(true);
      })
      .catch(err => {
        console.log("1703 인터페이스 에러: ", err);
      });
  };

  const itemStateFn = value => {
    // const value = JSON.stringify(testData);
    // const nativeReturnData = JSON.parse(value);
    const nativeReturnData = value;
    let putDataList = dataList;

    if (value) {
      if (nativeReturnData.command === "delete") {
        if (parseInt(nativeReturnData.data[0].fileCnt) === 0) {
          for (let i = 0; i < nativeReturnData.data.length; i++) {
            setDataList(
              dataList.filter(
                e => e.seqNo != parseInt(nativeReturnData.data[i].masterKey)
              )
            );
          }
        } else {
          putDataList = putDataList.map(data =>
            data.seqNo == nativeReturnData.data[0].masterKey
              ? {
                  ...data,
                  fileCnt: nativeReturnData.data[0].fileCnt,
                }
              : data
          );
          setDataList(putDataList);
        }
      } else {
        for (let i = 0; i < nativeReturnData.data.length; i++) {
          if (parseInt(nativeReturnData.data[i].fileCnt) === 0) {
            setDataList(
              dataList.filter(
                e => e.seqNo != parseInt(nativeReturnData.data[i].masterKey)
              )
            );
          } else {
            putDataList = putDataList.map(data =>
              data.seqNo == nativeReturnData.data[0].masterKey
                ? {
                    ...data,
                    fileCnt: nativeReturnData.data[0].fileCnt,
                  }
                : data
            );
            setDataList(putDataList);
          }
        }
      }
    } else {
      request1703();
    }
  };

  useEffect(() => {
    if (itemState.reload) {
      itemStateFn(itemState.data);
      // 체크박스 초기화
      $("input:checkbox").prop("checked", false);
      setCheckedSeqNo([]);
      setIsCheckAll(false);

      if ($(".confirm-layer").hasClass("on")) {
        closeLayerFn($(".confirm-layer"));
      }

      requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);

      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
    }
  }, [itemState.reload]);

  useEffect(() => {
    if (pageState.reload === 1) {
      request1703();
      // 체크박스 초기화
      $("input:checkbox").prop("checked", false);
      setCheckedSeqNo([]);
      setIsCheckAll(false);

      if ($(".confirm-layer").hasClass("on")) {
        closeLayerFn($(".confirm-layer"));
      }
      requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
    }
  }, [pageState.reload]);

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, [phonecfg.version]);

  useLayoutEffect(() => {
    if (!loading) {
      request1703();
      requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
    }
  }, [loading]);

  const fn_uploadRequest = () => {
    let masterKeysParam = settingMasterKey();
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "upload",
      userToken: userinfo.userToken.toString(),
      masterKeys: masterKeysParam,
      bizType: "ED",
      bizName: "기타입력자료",
      bizDtlType: "",
      viewYN: "Y",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "1",
    });
  };

  const settingMasterKey = () => {
    let returnKey = [];
    checkedSeqNo.map(m =>
      returnKey.push({
        masterKey1: m.toString(),
        masterKey2: "",
        masterKey3: "",
      })
    );

    return returnKey;
  };

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="입력자료"
        msgCount={msgCount}
        goToUrl="/"
        color="purple"
        bottom={
          checkedSeqNo.length > 0 && (
            <SectionDiv>
              <div
                className="two-btns-area"
                style={{ position: "relative", bottom: "100px" }}>
                <a
                  onClick={() => {
                    checkedSeqNo.length > 0 && fn_uploadRequest();
                  }}
                  className="btn-aftersave"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    background: checkedSeqNo.length > 0 ? "black" : "#d0d0d0",
                  }}>
                  병원 전송
                </a>
              </div>
            </SectionDiv>
          )
        }>
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} />
          {/* /subTabMenu */}

          {/* 검색폼 */}
          <div className="pr-section"></div>
          {/* / 검색폼 */}

          <div className="sub-contents">
            {/* 영상 리스트 */}
            <SubTitlle>자료등록</SubTitlle>
            <div
              style={{ position: "relative", padding: "15px 0px" }}
              onClick={() => etcInputClick()}>
              <InputArea>
                <div
                  style={{
                    margin: "0",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}>
                  <div style={{ display: "inline-block", textAlign: "center" }}>
                    <img src={IC.etc.IC_BLACK_PLUS} />
                    <p>
                      <b>자료를 등록하세요</b>
                    </p>
                  </div>
                </div>
              </InputArea>
            </div>

            <SubTitlle>입력자료</SubTitlle>
            <div style={{ position: "relative", padding: "15px 5px" }}>
              {dataList != null ? (
                <Fragment>
                  {dataList.length > 0 ? (
                    <OtherInspactionComponent
                      openConfirmLayer={openConfirmLayer}
                      request1703={request1703}
                      dataList={dataList}
                      setDeleteSeqNo={setDeleteSeqNo}
                      isCheckAll={isCheckAll}
                      setIsCheckAll={setIsCheckAll}
                      checkedSeqNo={checkedSeqNo}
                      setCheckedSeqNo={setCheckedSeqNo}
                    />
                  ) : (
                    <Nothing />
                  )}
                </Fragment>
              ) : (
                <SkeletonPmr />
              )}
            </div>
          </div>
        </div>
      </Container>
      <DateLayer handleDate={handleDate} />
      <AlertLayer
        priv="priv"
        title=""
        msg="요청한 파일을 삭제하지 못했습니다."
      />
      <ConfirmLayer
        priv="priv"
        title="개인진료기록 삭제"
        msg="삭제한 파일은 다시 복구할 수 없습니다. <br /> 정말 삭제 하겠습니까?"
        handleCancelCB={fnCancelConfirmLayer}
        handleConfirmCB={fnConfirmLayer}
      />
    </Fragment>
  );
};

const Nothing = (props) => {
  return(
      <div className="nothing-box">
          <div>
              <img src={NothingImg} alt="" />
              <p>
                  등록된 자료가 없습니다.<br/>
              </p>
          </div>
      </div>
  );
}

const InputArea = styled.div`
  /* Rectangle 21 */
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  left: 15px;
  top: 185px;
  background: #e6e7e8;
  border: 1px solid #c9c9c9;
  border-radius: 16px;
`;

const InputList = styled.div`
  /* card02 */
  box-sizing: border-box;

  width: 100%;
  height: 100px;
  left: 15px;
  top: 404px;

  background: #ffffff;
  border: 2px solid #6a62e6;
  border-radius: 8px;
`;

const SubTitlle = styled.div`
  width: 49px;
  height: 15px;
  left: 23px;
  padding-left: 5px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  /* identical to box height */

  color: #000000;
`;

const SectionDiv = styled.div`
  padding-top: 32px;
  padding-left: 25px;
  padding-right: 25px;
`;

const BottomBtn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 148px;
  gap: 10px;

  position: absolute;
  width: 348px;
  height: 41px;
  left: calc(50% - 348px / 2 - 2px);
  top: calc(50% - 41px / 2 + 394.5px);

  background: #c9c9c9;
  border-radius: 8px;
`;